import StripePayment from "react-migration/components/StripePayment/StripePayment";
import {
  AttemptChargeParams,
  PaymentResponse,
} from "react-migration/components/StripePayment/typings";
import { useGlobalState, Stores } from "react-migration/lib";
import { fetchPost } from "src/js/api/client";
import { PaymentIntent } from "@stripe/stripe-js";
type StripePaymentProps = {
  amount: number;
  loading: boolean;
};

const Payment = ({ amount, ...rest }: StripePaymentProps) => {
  const [{ orientation, center, site_id, sku_id }, { updateStore }] = useGlobalState(
    Stores.osMapPrint
  );
  const handleAttemptCharge = async (
    { stripeCharge, amount }: AttemptChargeParams,
    onCompleted: (res: PaymentResponse) => void
  ) => {
    try {
      updateStore({
        saving: true,
      });
      const payload = {
        orientation,
        center,
        site_id,
        stripeCharge,
        pounds: amount / 100,
      };
      const url = `/map-printing/os-mm/sku/${sku_id}/purchase`;
      const { abort, result: promise } = fetchPost(url, payload);
      const response = await promise;
      if (!response.ok) {
        throw new Error("" + response.status);
      }
      const responseJson = await response.json();
      const {
        intent,
        printModel,
      }: {
        intent: PaymentIntent & { error_message: string };
        printModel: { _id: string };
      } = responseJson;
      updateStore({
        activeRequestAbort: abort,
        ...(printModel || {}),
        print_id: printModel && printModel._id,
      });
      onCompleted({
        client_secret: intent.client_secret || "",
        status: intent.status,
        id: intent.id,
        error_message: intent.error_message,
      });
      if (intent.status === "succeeded") {
        updateStore({
          step: "complete",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      updateStore({
        saving: false,
      });
    }
  };

  return (
    <StripePayment
      {...rest}
      showTitle={false}
      amount={amount}
      attemptCharge={handleAttemptCharge}
      mode="dark"
      isFormInvalid={false}
    />
  );
};

export default Payment;
